var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.totalLoanAmount
    ? _c(
        "div",
        { attrs: { id: "submission-block-container" } },
        [
          _c("incident-message", {
            staticClass: "p-2",
            attrs: { "service-name": "filogix" },
            on: { update: _vm.handleIncidentUpdate },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c(
              "form",
              {
                attrs: { id: "lender-submit-form" },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c("div", { staticClass: "row align-items-end" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm col-md-4 col-lg-10 form-container" },
                    [
                      _c("h6", { staticClass: "form-title font-sm mb-0" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("direct-to-lender.lenderSubmit.loanAmount")
                            ) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "material-input",
                        {
                          staticClass: "dollar-prepend",
                          attrs: {
                            value: _vm.totalLoanAmount,
                            label: _vm.$t(
                              "direct-to-lender.lenderSubmit.loanAmount"
                            ),
                            "hidden-label": "",
                            "label-for": "loan-amount",
                          },
                        },
                        [
                          _c("currency-input", {
                            attrs: {
                              id: "loan-amount",
                              value: _vm.totalLoanAmount,
                              disabled: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm col-md-4 col-lg-2 form-container" },
                    [
                      _c("h6", { staticClass: "form-title font-sm mb-0" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("direct-to-lender.lenderSubmit.rate")
                            ) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "material-input",
                        {
                          staticClass: "perc-append",
                          attrs: {
                            value: _vm.netRate,
                            disabled: "",
                            label: _vm.$t("direct-to-lender.lenderSubmit.rate"),
                            "hidden-label": "",
                            "label-for": "rate",
                          },
                        },
                        [
                          _c("rate-input", {
                            attrs: {
                              id: "rate",
                              value: _vm.netRate,
                              disabled: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm col-md-4 col-lg-5 form-container" },
                    [
                      _c(
                        "h6",
                        { staticClass: "form-title font-sm mb-0" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "direct-to-lender.lenderSubmit.lenderType"
                                )
                              )
                          ),
                          _c("input-required-indicator"),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "material-input",
                        {
                          staticClass: "form-group-material-no-label pb-3",
                          attrs: { "no-label": "" },
                          model: {
                            value: _vm.localSubmissionData.lenderType,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.localSubmissionData,
                                "lenderType",
                                $$v
                              )
                            },
                            expression: "localSubmissionData.lenderType",
                          },
                        },
                        [
                          _c("v-select-field", {
                            staticClass: "simple-dd",
                            attrs: {
                              options: _vm.lenderTypeOptions,
                              scenario: "simple",
                              "default-value":
                                _vm.localSubmissionData.lenderType,
                              placeholder: _vm.$t(
                                "direct-to-lender.lenderSubmit.lenderType"
                              ),
                              name: "lenderType",
                            },
                            on: {
                              "option:selected": function (selectedOption) {
                                return (_vm.localSubmissionData.lenderType =
                                  selectedOption.value)
                              },
                              clear: _vm.clearLenderType,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm col-md-4 col-lg-5 form-container" },
                    [
                      _c(
                        "h6",
                        { staticClass: "form-title font-sm mb-0" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "direct-to-lender.lenderSubmit.submissionMethod"
                                )
                              )
                          ),
                          _c("input-required-indicator"),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "material-input",
                        {
                          staticClass: "form-group-material-no-label pb-3",
                          attrs: { "no-label": "" },
                          model: {
                            value: _vm.localSubmissionData.submissionMethod,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.localSubmissionData,
                                "submissionMethod",
                                $$v
                              )
                            },
                            expression: "localSubmissionData.submissionMethod",
                          },
                        },
                        [
                          _c("v-select-field", {
                            staticClass: "simple-dd",
                            attrs: {
                              options: _vm.submissionMethodSelectOptions,
                              placeholder: _vm.$t(
                                "direct-to-lender.lenderSubmit.submissionMethod"
                              ),
                              "default-value":
                                _vm.localSubmissionData.submissionMethod,
                              name: "submissionMethod",
                            },
                            on: {
                              "option:selected": _vm.handleSelectSubmission,
                              clear: _vm.clearSubmissionMethod,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm col-md-2 form-container" },
                    [
                      _c("h6", { staticClass: "form-title font-sm mb-0" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("direct-to-lender.lenderSubmit.lob")
                            ) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("material-input", {
                        attrs: {
                          value: _vm.lineOfBusiness,
                          "custom-expression": "lineOfBusiness",
                          disabled: "",
                          label: _vm.$t("direct-to-lender.lenderSubmit.lob"),
                          "hidden-label": "",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm col-md-4 form-container" },
                    [
                      _c(
                        "h6",
                        { staticClass: "form-title font-sm mb-0" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("global.doorr.lender"))
                          ),
                          _c("input-required-indicator"),
                          _vm._v(" "),
                          _vm.loading.lenders
                            ? _c("inline-loader", {
                                staticClass: "mx-2",
                                attrs: { width: "12px", height: "12px" },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "material-input",
                        {
                          staticClass: "form-group-material-no-label pb-3",
                          model: {
                            value: _vm.localSubmissionData.lenderName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.localSubmissionData,
                                "lenderName",
                                $$v
                              )
                            },
                            expression: "localSubmissionData.lenderName",
                          },
                        },
                        [
                          _c("v-select-field", {
                            staticClass: "simple-dd",
                            attrs: {
                              options: _vm.lenders.filter(function (
                                lender,
                                index
                              ) {
                                return _vm.lenders.indexOf(lender) === index
                              }),
                              scenario: "lenderName",
                              placeholder: _vm.$t("global.doorr.lender"),
                              "default-value":
                                _vm.localSubmissionData.lenderName,
                              name: "lenderName",
                              "remove-duplicates-by": "label",
                            },
                            on: {
                              "option:selected": _vm.updateLenderName,
                              clear: _vm.clearLenderName,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showOtherLender
                    ? _c(
                        "div",
                        { staticClass: "col-sm col-md-4 form-container" },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "direct-to-lender.lenderSubmit.lenderName"
                                    )
                                  )
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("material-input", {
                            staticClass: "form-group-material-no-label",
                            model: {
                              value: _vm.otherLenderName,
                              callback: function ($$v) {
                                _vm.otherLenderName = $$v
                              },
                              expression: "otherLenderName",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isCurrentLenderAuthorized
                    ? _c(
                        "div",
                        { staticClass: "mt-4" },
                        [
                          _c("notification-popover", {
                            attrs: {
                              show: "",
                              disabled: "",
                              boundary: "viewport",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "popoverContent",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t(
                                              "direct-to-lender.lenderSubmit.selectedLenderNotAuthorized"
                                            )
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              3204487428
                            ),
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentLenderProducts.length,
                          expression: "currentLenderProducts.length",
                        },
                      ],
                      staticClass: "col-sm col-md-4 form-container",
                    },
                    [
                      _c(
                        "h6",
                        { staticClass: "form-title font-sm mb-0" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "direct-to-lender.lenderSubmit.lenderProduct"
                                )
                              )
                          ),
                          _c("input-required-indicator"),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "material-input",
                        {
                          staticClass: "pb-3",
                          attrs: { "no-label": "" },
                          model: {
                            value: _vm.localSubmissionData.lenderProduct,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.localSubmissionData,
                                "lenderProduct",
                                $$v
                              )
                            },
                            expression: "localSubmissionData.lenderProduct",
                          },
                        },
                        [
                          _c("v-select-field", {
                            staticClass: "simple-dd no-span",
                            attrs: {
                              placeholder: _vm.$t(
                                "direct-to-lender.lenderSubmit.lenderProduct"
                              ),
                              options: _vm.currentLenderProducts,
                              "default-value":
                                _vm.localSubmissionData.lenderProduct,
                              scenario: "lenderProduct",
                              language: _vm.language,
                              name: "lenderProduct",
                            },
                            on: {
                              "option:selected": function (val) {
                                return (_vm.localSubmissionData.lenderProduct =
                                  val.value)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _vm.localSubmissionData.submissionMethod == "electronic" &&
                !_vm.isLenderBlocked
                  ? _c(
                      "field",
                      {
                        attrs: {
                          title: _vm.$tc("documents.document", 1),
                          icon: "fa-info-circle",
                          "icon-tooltip": _vm.$t(
                            "documents.electronicDocumentsToLenderTip"
                          ),
                        },
                      },
                      [
                        _c(
                          "material-input",
                          [
                            _c("v-select-field", {
                              attrs: {
                                options: _vm.documentsToLender,
                                "no-options-text": _vm.docsToLenderMessage,
                                "default-value": _vm.docsToLender,
                                action: "clear",
                                multiple: "",
                                "has-checkboxes": "",
                                "deselect-from-dropdown": "",
                                "loading-options": _vm.loadingOptions,
                                scenario: "documents",
                                label: "label",
                                name: "documents",
                                placeholder: _vm.$tc("documents.document", 2),
                              },
                              on: {
                                "option:selected": _vm.handleSelectDocument,
                                "option:unselected": _vm.handleDeselectDocument,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.shouldShowDocsToLenderDisclaimer
                  ? _c("div", { staticClass: "row mb-4" }, [
                      _c(
                        "div",
                        { staticClass: "align-items-sm-start col d-flex" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "pretty p-icon p-jelly p-smooth p-curve mt-2",
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.lenderDocSubmissionDisclaimerAccepted,
                                    expression:
                                      "lenderDocSubmissionDisclaimerAccepted",
                                  },
                                ],
                                staticClass: "form-check-input",
                                attrs: {
                                  id: "lenderDocSubmissionDisclaimer",
                                  type: "checkbox",
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.lenderDocSubmissionDisclaimerAccepted
                                  )
                                    ? _vm._i(
                                        _vm.lenderDocSubmissionDisclaimerAccepted,
                                        null
                                      ) > -1
                                    : _vm.lenderDocSubmissionDisclaimerAccepted,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a =
                                        _vm.lenderDocSubmissionDisclaimerAccepted,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.lenderDocSubmissionDisclaimerAccepted =
                                            $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.lenderDocSubmissionDisclaimerAccepted =
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.lenderDocSubmissionDisclaimerAccepted =
                                        $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm._m(0),
                            ]
                          ),
                          _vm._v(" "),
                          _c("label", {
                            staticStyle: { cursor: "pointer" },
                            attrs: { for: "lenderDocSubmissionDisclaimer" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "direct-to-lender.lenderSubmit.documentDisclaimer"
                                )
                              ),
                            },
                          }),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row align-items-end" }, [
                  _c(
                    "div",
                    { staticClass: "col-lg col-md-12" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center justify-content-between",
                        },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "direct-to-lender.lenderSubmit.lenderNote"
                                    )
                                  ) +
                                  "\n              "
                              ),
                              _vm.loading.note
                                ? _c("inline-loader", {
                                    staticClass: "mx-2",
                                    attrs: { width: "12px", height: "12px" },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn bold btn-primary btn-sm mb-2",
                              on: {
                                click: _vm.handleAutoComposeLenderNoteClick,
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticStyle: { "margin-right": "4px" },
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    height: "1em",
                                    viewBox: "0 0 576 512",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      fill: "#FFFF",
                                      d: "M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "direct-to-lender.lenderSubmit.autoCompose"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("generate-notes-modal", {
                            ref: "generateNotesModal",
                            attrs: {
                              username: _vm.agentUsername,
                              "client-username": _vm.clientUsername,
                              "mortgage-type": _vm.mortgageType,
                              "application-id": _vm.applicationId,
                            },
                            on: { note: _vm.handleAutoComposedNote },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("resizable-text-area", {
                        staticClass: "w-100",
                        staticStyle: {
                          "min-height": "100px",
                          resize: "vertical",
                        },
                        attrs: {
                          id: "lender-note",
                          value: _vm.localSubmissionData.lenderNote,
                          rows: "3",
                          "max-length": "4000",
                        },
                        on: {
                          input: function (val) {
                            return (_vm.localSubmissionData.lenderNote = val)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.lenderNoteTooLong
                        ? _c(
                            "div",
                            {
                              staticClass: "text-danger",
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                "justify-content": "flex-end",
                              },
                            },
                            [
                              _c("icon", {
                                staticStyle: { "margin-right": "5px" },
                                attrs: { name: "exclamation-circle" },
                              }),
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "direct-to-lender.lenderSubmit.reduceTheSizeOfYourNote"
                                    )
                                  ) +
                                  "\n            (" +
                                  _vm._s(
                                    _vm._f("formatIntegerQuantity")(
                                      _vm.lenderNoteLength
                                    )
                                  ) +
                                  "/4,000)\n          "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "d-none",
                          attrs: { for: "lender-note" },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("direct-to-lender.lenderSubmit.lenderNote")
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-footer bg-light d-flex justify-content-end" },
            [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "open-window-popover",
                      rawName: "v-open-window-popover",
                      value: {
                        url: _vm.windowPopoverUrl,
                        width: 900,
                        height: 600,
                      },
                      expression:
                        "{\n        url: windowPopoverUrl,\n        width: 900,\n        height: 600\n      }",
                    },
                  ],
                  staticClass: "btn bold btn-white btn-sm mr-2",
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("global.words.validate")) +
                      "\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("notification-popover", {
                attrs: {
                  "keep-open": _vm.missingFilogixDetails,
                  container: "#submission-block-container",
                  boundary: "#submission-block-container",
                  placement: "topleft",
                  type: _vm.validationsPopoverType,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "popoverContent",
                      fn: function () {
                        return [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.lenderSubmitText) +
                              "\n      "
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "popoverTarget",
                      fn: function () {
                        return [
                          _vm.showButton
                            ? _c(
                                "button",
                                {
                                  ref: "submitButton",
                                  staticClass:
                                    "btn bold btn-primary btn-sm validation-button",
                                  attrs: {
                                    id: "lender-submit-button",
                                    type: "submit",
                                    disabled: _vm.disableSubmit,
                                  },
                                  on: { click: _vm.handleSubmit },
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm.submitButtonText) +
                                      "\n          "
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "validation-icon" },
                                    [
                                      _vm.loading.validations
                                        ? _c("inline-loader", {
                                            attrs: { variant: "secondary" },
                                          })
                                        : _c("i", {
                                            staticClass: "fa",
                                            class: _vm.validButtonIcon,
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1285316744
                ),
              }),
            ],
            1
          ),
        ],
        1
      )
    : _c("div", [
        _c("div", { staticClass: "card-body" }, [
          _c(
            "div",
            {
              staticClass: "row justify-content-center align-items-center pb-4",
            },
            [
              _c(
                "no-results",
                {
                  attrs: {
                    "img-src": require("@Shared/@Assets/img/application-missing.png"),
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(
                          "direct-to-lender.lenderSubmit.selectApplicationAbove"
                        )
                      ) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon fa fa-check" }),
      _vm._v(" "),
      _c("label", {
        staticClass: "hidden-text",
        attrs: { for: "lenderDocSubmissionDisclaimer" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }